import { Component, ViewChild } from '@angular/core';
import { NavigationService } from '../../services/navigation.service';
import { RegistrationService } from '../../services/registration.service';
import { VariablesService } from '../../services/variables.service';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
    templateUrl: './demographics.component.html',
    standalone: false
})
export class DemographicsComponent {
  @ViewChild('demographicsForm') form;

  isSubmitting: boolean;
  attendee: any;
  firstTime;
  isFormCompleted=false;
  
  othergender;
  othereth;

  age;
  gender;
  ethnicity;
  bizjob;
  employeenums;
  exp;
  aum;
  affiliation;
  isalt;
  isbuf;
  isemp;
  isetf;
  isnet;
  ismodel;
  issma;
  aiv;
  sma;
  breakout;
  ce;
  dccontact;
  braindate;
  enrollment;
  constructor(
    private navigationService: NavigationService,
    private registrationService: RegistrationService,
    private variablesService: VariablesService
  ) {
    this.attendee = this.registrationService.getAttendee({});
    this.enrollment = this.registrationService.getEnrollment({});

    this.firstTime = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.FIRST_TIME.ID,
      {}
    );
    console.log(this.firstTime.Value);
    this.age = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.AGE.ID,
      {}
    );
    this.gender = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.GENDER.ID,
      {}
    );
    this.ethnicity = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.ETHNICITY.ID,
      {}
    );
    this.bizjob = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.BIZJOB.ID,
      {}
    );
    this.employeenums = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.EMPLOYEENUMS.ID,
      {}
    );
    this.exp = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.EXP.ID,
      {}
    );
    this.aum = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.AUM.ID,
      {}
    );
    this.affiliation = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.AFFILIATION.ID,
      {}
    );
    this.isalt = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.ISALT.ID,
      {}
    );
    this.isbuf = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.ISBUF.ID,
      {}
    );
    this.isemp = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.ISEMP.ID,
      {}
    );
    this.isetf = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.ISETF.ID,
      {}
    );
    this.isnet = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.ISNET.ID,
      {}
    );
    this.ismodel = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.ISMODEL.ID,
      {}
    );
    this.issma = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.ISSMA.ID,
      {}
    );
    this.aiv = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.AIV.ID,
      {}
    );
    this.sma = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.SMA.ID,
      {}
    );
    this.breakout = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.BREAKOUT.ID,
      {}
    );
    this.ce = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.CE.ID,
      {}
    );
    this.dccontact = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.DCCONTACT.ID,
      {}
    );
    this.braindate = registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.BRAINDATE.ID,
      {}
    );
    console.log(this.firstTime.Value);

  }



  /**
   * @function back
   * @description Uses [navigation.service.back()] to go back to previous page.
   */
  back() {
    this.navigationService.back();
  }

  /**
   * @function forward
   * @description Checks if form is valid then uses [navigation.service.forward()] to go forward to next page.
   */
  forward(form) {
    this.isFormCompleted=true;
    if (form.valid) {
      // if (this.gender.Value === 'Other' && this.othergender) {
      //   this.gender.Value = 'Other: ' + this.othergender;
      // }
      // if (this.ethnicity.Value === 'Other' && this.othereth) {
      //   this.ethnicity.Value = 'Other: ' + this.othereth;
      // }
    this.isSubmitting = true;
    this.navigationService.forward();
    }
  }

  checkToggle($event,model){
    if($event.checked){
      model.Value = "Yes";
    }else{
      model.Value = "";
    }
  }
}
